import React, { useEffect } from 'react'
import { CloseIcon } from '@fourthwall/icons'
import { useFocus } from '../../hooks/useFocus'
import { Icon } from '../Icon'
import * as S from './styled'
import type { AlertProps } from './types'

export const Alert = ({ message, type = 'info', onClose }: AlertProps) => {
  const [closeButtonRef, setCloseButtonFocus] = useFocus()

  useEffect(() => {
    // NOTE: we require this timeout due to Screen Reader issue with reading the content of this box
    const timeout = setTimeout(() => {
      setCloseButtonFocus()
    }, 200)

    return () => clearTimeout(timeout)
  }, [setCloseButtonFocus])

  return (
    <S.Container $type={type} role="alert">
      <S.Message>{message}</S.Message>
      {onClose && (
        <S.Close title="Close" onClick={onClose} data-testid="Alert.Close" ref={closeButtonRef}>
          <Icon component={CloseIcon} height={16} ariaLabel="close" />
        </S.Close>
      )}
    </S.Container>
  )
}
